import { getAuthHeader } from '@/constants/constants';
import api from '@/lib/api';

export interface FAQ {
    id: string;
    question: string;
    answer: string;
    faqCategoryId: string;
    position: number;
    createdAt: string;
    updatedAt: string;
    faqCategory: {
        name: string;
    };
}

export interface FAQCategory {
    id: string;
    name: string;
    faqs: FAQ[];
}

export interface FAQResponse {
    success: boolean;
    message: string;
    data: {
        faq: FAQCategory[];
    };
}

export const getFAQs = async (): Promise<FAQResponse> => {
    try {
        const response = await api.get('/faq');
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const createFAQ = async (faqData: {
    question: string;
    answer: string;
    faqCategoryId: string;
}): Promise<unknown> => {
    try {
        const response = await api.post('/faq', faqData, { headers: getAuthHeader() });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updateFAQ = async (id: string, faqData: {
    question: string;
    answer: string;
    faqCategoryId: string;
}): Promise<unknown> => {
    try {
        const response = await api.put(`/faq/${id}`, faqData, { headers: getAuthHeader() });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const deleteFAQ = async (id: string): Promise<unknown> => {
    try {
        const response = await api.delete(`/faq/${id}`, { headers: getAuthHeader() });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const rearrangeFAQs = async (categoryId: string, faqIds: string[]): Promise<unknown> => {
    try {
        const response = await api.put(`/faq/rearrange/${categoryId}`,
            { faqIds },
            { headers: getAuthHeader() }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};